export default __webpack_public_path__ + "static/portfolio-a7bcc30db14e578f03df78b713fa803a.jpg";